// TODO:
/* SHOULD READ ALL THESE VALUE FROM DB, WILL HAVE TO UPDATED WHEN TIME AVAILABLE */

const TYPES = {
  1: 'Single choice',
  2: 'Multichoice',
  3: 'Code free time',
  4: 'Code limit time',
  5: 'Free Text Entry',
  6: 'Single choice none valid',
  7: 'Multi choice none valid'
};

const DIFFICULTIES = {
  1: 'Easy',
  2: 'Medium',
  3: 'Hard',
  4: 'Expert'
};

const TYPE_BY_NAME = {
  SINGLE_CHOICE: 1,
  MULTI_CHOICE: 2,
  CODE_FREE: 3,
  CODE_LIMIT_TIME: 4,
  FREE_ENTRY: 5,
  SINGLE_CHOICE_NONE_VALID: 6,
  MULTI_CHOICE_NONE_VALID: 7
};

export default {
  TYPES,
  DIFFICULTIES,
  TYPE_BY_NAME
};
